import React, { useEffect,Component,useState,useRef, useTransition } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import {useHistory,useParams} from 'react-router-dom';
import {ApiService} from '../../containers/Services/apiservice';
let apiServices = new ApiService();
function MfIndexDetail(){
    const [mutualfund , setmutualfund] = useState({})
    const [CANid, setCANid] = useState('');
    const [UserBankData , SetUserBankData] = useState({})
    const [Bankno, setBankno] = useState();
    const [errorMessage , setErrorMessage] = useState('')
    const [ReqError, setReqError] = useState('')
    const [ReqErrorMsg , setReqErrorMsg] = useState('')
    const [spinnerLoading , setSpinnerLoading] = useState()
    const { id } = useParams();
    const didMountRef = useRef(true);
    const history = useHistory()
    useEffect(() => {
        if (didMountRef.current) {  
                   const dataStringuser = {
          } 
          apiServices.getUserData(dataStringuser).then(result => {
            if(result.data.status == 'success'){
                setCANid(result.data.data.gs_can_id);
            }
            else if(result.data.status == "error" && result.data.message == "Session expired"){
              localStorage.removeItem('AUTH_TOKEN');
              // alert(result.data.message)
              setSpinnerLoading(false)
              history.push("/login")           
          }
          else{
            alert(result.data.message)
            setSpinnerLoading(false)
            return false
                }
        })  
    const dataString = {
        "id": id,
        } 
        apiServices.getmutualFunddetailData(dataString).then(res => {
        if(res.data.status=='success'){
          setmutualfund(res.data.data);
        }
          else if(res.data.status == "error" && res.data.message == "Session expired"){
            localStorage.removeItem('AUTH_TOKEN');
            // alert(res.data.message)
            setSpinnerLoading(false)
            history.push("/login")           
        }
        else{
          alert(res.data.message)
          setSpinnerLoading(false)
        }
        })
        getusrbanks()
    }
        didMountRef.current = false;
    });
    const getusrbanks = () => {
            const dataString = {
              } 
              apiServices.getusercanbankdata(dataString).then(res => {
                if(res.data.status=='success'){   
                    SetUserBankData(res.data.data)
                }  
                else if(res.data.status == "error" && res.data.message == "Session expired"){
                  localStorage.removeItem('AUTH_TOKEN');
                  // alert(res.data.message)
                  setSpinnerLoading(false)
                  history.push("/login")           
              }
              else{
                alert(res.data.message)
                setSpinnerLoading(false)
                return false
              }  
    }
      )}
      const siptransaction = () => {
        // console.log(InputData);return false;
          {
            if(mutualfund.amount == '' || mutualfund.amount == null){              
              setErrorMessage(' Amount Fields Are Required.');
              return false;
            }
            else if(mutualfund.payment_mode == '' || mutualfund.payment_mode == null){
             setErrorMessage(' Payment Mode Fields Are Required.');
              return false;
            }
            else if(mutualfund.sipfrequency == '' || mutualfund.sipfrequency == null){
             setErrorMessage('All Frequency Of Sip Fields Are Required.');
              return false;
            }
            else if(mutualfund.sipdate == '' || mutualfund.sipdate == null){
                setErrorMessage('All Date To Deduct Sip Amount Fields Are Required.');
                return false;
              }
            else{
              setReqError(0);
            }
          }
        }
     return(
        <>
       <Header/> 
       <section className='bg-gray-light section-small'>
        <div className="container">
        <div className='mpanel mg-b-15'>
        <div className='mpanel-header'>
          <h5 className='mg-b-0 fw600'>{mutualfund.plan_name}</h5>
        </div>
        <div className='mpanel-header'>
            <h5 className='mg-b-0 fw600'>ARN : 249633</h5> 
            </div>
            <div className='mpanel-header'>
            <h5 className='mg-b-0 fw600'>{CANid}</h5>
            </div>
            <hr/>
            <div className='mpanel-body ecan-form'>
          <div className="row">
          <div className="col-lg-12">
<button type='button'>One time</button>
<button type='button'>SIP</button>
            </div>
            </div>
            </div>
            {/* <div className='mpanel-body ecan-form'>
          <div className="row">
          <div className="col-lg-12">
                    <div className="ecan-form-group">
                        <label>Amount<span style={{color:'#ff0000'}}>*</span></label>
                        <input name="amount"  type="number" ></input>
                    </div>
                    </div>
                    <div className="col-lg-12">
                    <div className="ecan-form-group">
                        <label>Payment Mode<span style={{color:'#ff0000'}}>*</span></label>
                        <select name="payment_mode" >
                        <option value="">Select</option>
                        <option value="OT">Net Banking</option> 
                        <option value="UP">UPI</option>
                        <option value="DM">PayEezz</option>
                        </select>
                    </div>
                    </div>  
                    <div className="col-lg-12">
                   <div className="ecan-form-group">
                       <label>Frequency Of Sip<span style={{color:'#ff0000'}}>*</span></label>
                       <select name="sipfrequency" >
                       <option value="">Select</option>
                       <option value="D">Daily</option> 
                       <option value="W">Weekly</option>
                       <option value="M">Monthly</option>
                       <option value="B">Bi-Monthly</option>
                       <option value="Q">Quarterly</option>
                       <option value="S">Semi-Annually</option>
                       <option value="A">Annually</option>
                       </select>
                   </div>
                   </div> 
                   
                   <div className="col-lg-12">
                   <div className="ecan-form-group">
                       <label>Date To Deduct Sip Amount<span style={{color:'#ff0000'}}>*</span></label>
                       <input name="sipdate" type="date"></input>
                   </div>
                   
                   </div> 
                   <div className='mpanel-header'>
                  <h5 className='mg-b-0 fw600'>Select Bank Details</h5>
        </div>
   <div className="col-lg-12">
                   <div className="ecan-form-group">
                       {/* <label>Select Bank Details<span style={{color:'#ff0000'}}>*</span></label> */}
                       {/* <select name="bankno" value={Bankno} onChange={(e) => setBankno(e.target.value)}>
                       {UserBankData.crb_bank_acc_no1 != null?
                        <option value="1">{UserBankData.crb_bank1} -- {UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X')} -- (Primary)</option>:'' 
                       }
                       {UserBankData.crb_bank_acc_no2 != null?
                        <option value="2">{UserBankData.crb_bank2} -- {UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X')}</option>:'' 
                       }
                       {UserBankData.crb_bank_acc_no3 != null?
                        <option value="3">{UserBankData.crb_bank3} -- {UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X')}</option>:'' 
                       }
                       </select> */}
                   {/* </div>
                   </div>  
                   {
    errorMessage!=''?<p className="text text-danger">{errorMessage}</p>:null
}   
                    <div className="theme-button mg-t-10" onClick={siptransaction}>
                    <a  className="btn">
                    Proceed
                    </a>
                </div>  
                  
          </div>
        </div>  */}
        </div>
        </div>
      </section>
       <Footer/>
        </>
    )
}
export default MfIndexDetail;